import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {connect} from 'react-redux';

import {Power3, TweenLite} from "gsap";
import ReactDOM from 'react-dom'

class ScrollToTop extends Component {

    static propTypes = {
        onClick: PropTypes.func,
        configurationScrollProgress: PropTypes.number
    }

    componentWillEnter(callback) {

        const dom = ReactDOM.findDOMNode(this)
        TweenLite.fromTo(dom, 0.5, {y: -dom.offsetHeight - 3}, {
            ease: Power3.easeInOut, y: 0, onComplete: () => {
                callback()
            }
        })

        this.setState({
            isAnimating: true
        })

    }

    componentWillLeave(callback) {

        const dom = ReactDOM.findDOMNode(this)
        TweenLite.to(dom, 0.5, {
            ease: Power3.easeOut, y: -dom.offsetHeight - 30, onComplete: () => {
                callback()
            }
        })

    }

    render() {

        return (

            <a className="scroll-to-top" onClick={this.props.onClick}>
                <div style={{width: (this.props.configurationScrollProgress * 100) + "%"}}></div>
            </a>
        )

    }

}


function mapStateToProps(state) {
    return {
        configurationScrollProgress: state.ui.configurationScrollProgress
    };
}

function mapDispatchToProps(dispatch) {
    return {};
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ScrollToTop);


/** WEBPACK FOOTER **
 ** ./src/components/ScrollToTop.js
 **/